import { SAVE_CURRENT_GROUP, SET_IS_GROUPED } from 'store/actions/ordersActions';

const isGrouped = () => {
  const savedToggleState = localStorage.getItem('isGrouped');
  if (savedToggleState === null) {
    localStorage.setItem('isGrouped', JSON.stringify(true));
    return true;
  } else {
    const parsedToggleState = JSON.parse(savedToggleState);
    return parsedToggleState;
  }
};

interface State {
  group: {
    id: string | null;
    items: {
      name: string | null;
      quantity: number | null;
      sku: string | null;
    }[];
    orderedFromAbroad: boolean;
    ordersInGroup: boolean;
  };
  isGrouped: boolean;
}

const INITIAL_STATE = {
  group: {
    id: null,
    items: [],
    orderedFromAbroad: false,
    ordersInGroup: false,
  },
  isGrouped: isGrouped(),
};

const ordersReducer = (state: State = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SAVE_CURRENT_GROUP:
      return { ...state, group: payload };
    case SET_IS_GROUPED:
      return { ...state, isGrouped: payload };
    default:
      return state;
  }
};

export default ordersReducer;
